import React, { useState, useEffect } from 'react';
import { Image, Box, Text } from '@chakra-ui/react';
import { getStorageUrl } from '../../utils/containerVanChecklistUtils';

interface StorageImageProps {
  storagePath: string;
  alt: string;
  w?: string;
  maxH?: string;
  boxSize?: string;
  objectFit?: "cover" | "contain" | "fill" | "none" | "scale-down";
  borderRadius?: string;
  border?: string;
  borderColor?: string;
  cursor?: string;
  onClick?: () => void;
  _hover?: object;
  bg?: string;
}

const StorageImage: React.FC<StorageImageProps> = ({
  storagePath,
  alt,
  onClick,
  ...imageProps
}) => {
  const [imageUrl, setImageUrl] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      try {
        setLoading(true);
        setError(false);
        const url = await getStorageUrl(storagePath);
        setImageUrl(url);
      } catch (err) {
        console.error('Error loading image:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (storagePath) {
      loadImage();
    }
  }, [storagePath]);

  if (loading) {
    return (
      <Box
        {...imageProps}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="gray.100"
      >
        <Text fontSize="xs" color="gray.500">Loading...</Text>
      </Box>
    );
  }

  if (error || !imageUrl) {
    return (
      <Box
        {...imageProps}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="gray.100"
      >
        <Text fontSize="xs" color="gray.500">Failed to load</Text>
      </Box>
    );
  }

  return (
    <Image
      src={imageUrl}
      alt={alt}
      onClick={onClick}
      {...imageProps}
    />
  );
};

export default StorageImage;